module.exports = __webpack_public_path__ + "static/ip-ikon1-068a53541d01845d03067deb0b59f591.png";